(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apollo-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const stars = (rating) =>
      '★'.repeat(Math.max(0, Math.min(5, Math.round(rating)))) +
      '☆'.repeat(Math.max(0, 5 - Math.round(rating)));
    const normalizeTitle = (value) =>
      String(value || '')
        .replace(/&amp;/g, '&')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

    document.querySelectorAll('[data-apollo-product-reviews]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const grid = root.querySelector('.apollo-reviews__grid');
      const summary = root.querySelector('.apollo-reviews__summary');
      const more = root.querySelector('[data-review-more]');
      const error = root.querySelector('[data-review-error]');
      const emptyProduct = root.querySelector('[data-empty-product]');
      const emptyStore = root.querySelector('[data-empty-store]');
      const pageSize = Number(root.dataset.pageSize) || 6;
      const apiBase = root.dataset.apiBase;
      const productHandle = root.dataset.productHandle;
      const productTitle = normalizeTitle(root.dataset.productTitle);
      const summaryCache = {};
      let active = 'product';
      let page = 1;
      let sortMode = 'newest';
      let ratingFilter = 'all';
      let photosOnly = false;
      let liveMode = true;
      let fallbackVisible = pageSize;

      const normalizedLiveReview = (review) => ({
        r: review.rating,
        h: review.heading,
        b: review.body,
        n: review.reviewerName,
        l: review.reviewerLocation,
        d: String(review.createdAt || '').slice(0, 10),
        p: review.productTitle,
        v: review.verifiedPurchase,
        i: Array.isArray(review.media) ? review.media.map((item) => item.url) : [],
        reply: review.storeReply,
        replyAt: review.storeRepliedAt,
      });

      const reviewCard = (review) => {
        const article = document.createElement('article');
        article.className = 'apollo-review';
        const starLine = document.createElement('div');
        starLine.className = 'apollo-reviews__stars';
        starLine.textContent = stars(review.r);
        starLine.setAttribute('aria-label', review.r + ' out of 5 stars');
        article.appendChild(starLine);

        if (review.h) {
          const heading = document.createElement('div');
          heading.className = 'apollo-review__title';
          heading.textContent = review.h;
          article.appendChild(heading);
        }

        if (review.b) {
          const body = document.createElement('p');
          body.className = 'apollo-review__body';
          body.textContent = review.b;
          article.appendChild(body);
        }

        if (Array.isArray(review.i) && review.i.length) {
          const photos = document.createElement('div');
          photos.className = 'apollo-review__photos';
          review.i.slice(0, 4).forEach((url, index) => {
            const image = document.createElement('img');
            image.src = url;
            image.alt = root.dataset.reviewPhoto + ' ' + (index + 1);
            image.loading = 'lazy';
            photos.appendChild(image);
          });
          article.appendChild(photos);
        }

        if (review.reply) {
          const reply = document.createElement('div');
          reply.className = 'apollo-review__reply';
          reply.textContent = review.reply;
          article.appendChild(reply);
        }

        const meta = document.createElement('div');
        meta.className = 'apollo-review__meta';
        const author = document.createElement('strong');
        author.textContent = review.n || root.dataset.anonymous;
        meta.appendChild(author);
        if (review.v) {
          const verified = document.createElement('span');
          verified.className = 'apollo-review__verified';
          verified.textContent = '✓ ' + root.dataset.verified;
          meta.appendChild(verified);
        }
        if (review.d) {
          const date = document.createElement('time');
          date.dateTime = review.d;
          date.textContent = new Date(review.d + 'T00:00:00').toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          });
          meta.appendChild(date);
        }
        article.appendChild(meta);
        return article;
      };

      const renderSummary = (scope) => {
        const data = summaryCache[scope];
        summary.textContent = '';
        if (!data || !data.count) return;
        const starLine = document.createElement('div');
        starLine.className = 'apollo-reviews__stars';
        starLine.textContent = stars(data.average);
        starLine.setAttribute('aria-label', data.average.toFixed(1) + ' out of 5 stars');
        const countLine = document.createElement('div');
        countLine.textContent = root.dataset.summary
          .replace('[average]', data.average.toFixed(1))
          .replace('[count]', data.count);
        summary.append(starLine, countLine);
      };

      const setEmptyState = (isEmpty) => {
        emptyProduct.hidden = !isEmpty || active !== 'product';
        emptyStore.hidden = !isEmpty || active !== 'store';
      };

      const setActiveTab = () => {
        root.querySelectorAll('[data-review-tab]').forEach((button) => {
          const selected = button.dataset.reviewTab === active;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
      };

      const query = (scope, endpoint, requestedPage) => {
        const params = new URLSearchParams({ scope });
        if (scope === 'product') params.set('product_handle', productHandle);
        if (endpoint === 'reviews') {
          params.set('sort', sortMode);
          params.set('page', requestedPage);
          params.set('limit', pageSize);
          if (ratingFilter !== 'all') params.set('rating', ratingFilter);
          if (photosOnly) params.set('photos', 'true');
        }
        return apiBase + '/' + endpoint + '?' + params.toString();
      };

      const getJson = async (url) => {
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(root.dataset.loadError);
        return response.json();
      };

      const loadLiveReviews = async (reset) => {
        if (reset) {
          page = 1;
          grid.replaceChildren();
        }
        grid.setAttribute('aria-busy', 'true');
        error.hidden = true;
        const data = await getJson(query(active, 'reviews', page));
        const reviews = data.reviews.map(normalizedLiveReview);
        reviews.forEach((review) => grid.appendChild(reviewCard(review)));
        setEmptyState(grid.children.length === 0);
        more.hidden = !data.hasMore;
        renderSummary(active);
        setActiveTab();
        grid.setAttribute('aria-busy', 'false');
      };

      const fallbackBase = () => {
        const all = Array.isArray(window.APOLLO_REVIEWS) ? window.APOLLO_REVIEWS : [];
        if (active === 'product') {
          return all.filter((review) => normalizeTitle(review.p) === productTitle);
        }
        return all.filter((review) => !String(review.p || '').trim());
      };

      const fallbackCurrent = () => {
        let reviews = [...fallbackBase()];
        if (ratingFilter === '5' || ratingFilter === '4') {
          reviews = reviews.filter((review) => Number(review.r) === Number(ratingFilter));
        }
        if (ratingFilter === 'lte3') {
          reviews = reviews.filter((review) => Number(review.r) <= 3);
        }
        if (photosOnly) {
          reviews = reviews.filter((review) => Array.isArray(review.i) && review.i.length);
        }
        reviews.sort((a, b) => {
          if (sortMode === 'oldest') return String(a.d).localeCompare(String(b.d));
          if (sortMode === 'highest') {
            return Number(b.r) - Number(a.r) || String(b.d).localeCompare(String(a.d));
          }
          if (sortMode === 'lowest') {
            return Number(a.r) - Number(b.r) || String(b.d).localeCompare(String(a.d));
          }
          return String(b.d).localeCompare(String(a.d));
        });
        return reviews;
      };

      const renderFallback = (reset) => {
        if (reset) fallbackVisible = pageSize;
        const reviews = fallbackCurrent();
        grid.replaceChildren(...reviews.slice(0, fallbackVisible).map(reviewCard));
        const base = fallbackBase();
        const count = base.length;
        const average = count
          ? base.reduce((total, review) => total + Number(review.r || 0), 0) / count
          : 0;
        summaryCache[active] = { count, average };
        renderSummary(active);
        setEmptyState(reviews.length === 0);
        more.hidden = fallbackVisible >= reviews.length;
        setActiveTab();
        grid.setAttribute('aria-busy', 'false');
      };

      const resetAndRender = async () => {
        if (!liveMode) {
          renderFallback(true);
          return;
        }
        try {
          await loadLiveReviews(true);
        } catch (loadError) {
          liveMode = false;
          if (root.dataset.staticFallback === 'true' && Array.isArray(window.APOLLO_REVIEWS)) {
            renderFallback(true);
          } else {
            grid.setAttribute('aria-busy', 'false');
            error.hidden = false;
          }
        }
      };

      root.querySelectorAll('[data-review-tab]').forEach((button) => {
        button.addEventListener('click', () => {
          active = button.dataset.reviewTab;
          resetAndRender();
        });
      });
      root.querySelector('[data-review-sort]').addEventListener('change', (event) => {
        sortMode = event.target.value;
        resetAndRender();
      });
      root.querySelector('[data-review-rating]').addEventListener('change', (event) => {
        ratingFilter = event.target.value;
        resetAndRender();
      });
      root.querySelector('[data-review-photos]').addEventListener('change', (event) => {
        photosOnly = event.target.checked;
        resetAndRender();
      });
      more.addEventListener('click', async () => {
        if (liveMode) {
          page += 1;
          try {
            await loadLiveReviews(false);
          } catch (loadError) {
            page -= 1;
            error.hidden = false;
          }
        } else {
          fallbackVisible += pageSize;
          renderFallback(false);
        }
      });

      Promise.all([
        getJson(query('product', 'summary', 1)),
        getJson(query('store', 'summary', 1)),
      ])
        .then(([productSummary, storeSummary]) => {
          summaryCache.product = productSummary;
          summaryCache.store = storeSummary;
          root.querySelector('[data-product-count]').textContent =
            '(' + productSummary.count + ')';
          root.querySelector('[data-store-count]').textContent = '(' + storeSummary.count + ')';
          active = productSummary.count ? 'product' : 'store';
          return loadLiveReviews(true);
        })
        .catch(() => {
          liveMode = false;
          const all = Array.isArray(window.APOLLO_REVIEWS) ? window.APOLLO_REVIEWS : [];
          const productCount = all.filter(
            (review) => normalizeTitle(review.p) === productTitle,
          ).length;
          const storeCount = all.filter((review) => !String(review.p || '').trim()).length;
          root.querySelector('[data-product-count]').textContent = '(' + productCount + ')';
          root.querySelector('[data-store-count]').textContent = '(' + storeCount + ')';
          active = productCount ? 'product' : 'store';
          if (root.dataset.staticFallback === 'true' && all.length) {
            renderFallback(true);
          } else {
            grid.setAttribute('aria-busy', 'false');
            error.hidden = false;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apollo-review-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-apollo-review-section]').forEach((section) => {
      if (section.dataset.apolloReviewReady === 'true') return;
      section.dataset.apolloReviewReady = 'true';

      const dialog = section.querySelector('[data-apollo-review-dialog]');
      const openButton = section.querySelector('[data-apollo-review-open]');
      const closeButton = section.querySelector('[data-apollo-review-close]');
      const form = section.querySelector('[data-apollo-review-form]');
      const submitButton = section.querySelector('[data-apollo-review-submit]');
      const message = section.querySelector('[data-apollo-review-message]');
      const photos = section.querySelector('[data-apollo-review-photos]');
      const turnstileElement = section.querySelector('[data-apollo-review-turnstile]');
      let turnstileWidgetId = null;
      let turnstilePollId = null;

      const renderTurnstile = () => {
        if (!turnstileElement || turnstileWidgetId !== null) return true;
        if (!window.turnstile) return false;
        turnstileWidgetId = window.turnstile.render(turnstileElement, {
          sitekey: turnstileElement.dataset.sitekey,
          theme: turnstileElement.dataset.theme || 'auto',
        });
        return true;
      };

      const waitForTurnstile = () => {
        if (renderTurnstile() || turnstilePollId !== null) return;
        let attempts = 0;
        turnstilePollId = window.setInterval(() => {
          attempts += 1;
          if (renderTurnstile() || attempts >= 50) {
            window.clearInterval(turnstilePollId);
            turnstilePollId = null;
          }
        }, 100);
      };

      openButton?.addEventListener('click', () => {
        dialog?.showModal();
        waitForTurnstile();
      });
      closeButton?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      photos?.addEventListener('change', () => {
        if (photos.files.length > 3) {
          photos.value = '';
          message.dataset.state = 'error';
          message.textContent = section.dataset.photoError;
        }
      });

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        message.textContent = '';
        delete message.dataset.state;
        submitButton.disabled = true;

        try {
          const response = await fetch('/apps/apollo-reviews/reviews', {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'application/json' },
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.error || section.dataset.submitError);

          message.dataset.state = 'success';
          message.textContent = result.message;
          form.reset();
          if (window.turnstile && turnstileWidgetId !== null) {
            window.turnstile.reset(turnstileWidgetId);
          }
        } catch (error) {
          message.dataset.state = 'error';
          message.textContent =
            error instanceof Error ? error.message : section.dataset.submitError;
        } finally {
          submitButton.disabled = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apollo-store-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const stars = (rating) =>
      '★'.repeat(Math.max(0, Math.min(5, Math.round(rating)))) +
      '☆'.repeat(Math.max(0, 5 - Math.round(rating)));

    document.querySelectorAll('[data-apollo-store-reviews]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const max = Number(root.dataset.max) || 12;
      const showPhotos = root.dataset.showPhotos === 'true';
      const apiBase = root.dataset.apiBase;
      const track = root.querySelector('.apollo-store-reviews__track');
      const summary = root.querySelector('.apollo-store-reviews__summary');
      const error = root.querySelector('[data-review-error]');

      const normalizeLive = (review) => ({
        r: review.rating,
        h: review.heading,
        b: review.body,
        n: review.reviewerName,
        d: String(review.createdAt || '').slice(0, 10),
        p: review.productTitle,
        v: review.verifiedPurchase,
        i: Array.isArray(review.media) ? review.media.map((item) => item.url) : [],
      });

      const renderSummary = (average, count) => {
        summary.replaceChildren();
        if (!count) return;
        const starLine = document.createElement('span');
        starLine.className = 'apollo-store-reviews__stars';
        starLine.textContent = stars(average);
        starLine.setAttribute('aria-label', average.toFixed(1) + ' out of 5 stars');
        const countLine = document.createElement('span');
        countLine.textContent = root.dataset.summary
          .replace('[average]', average.toFixed(1))
          .replace('[count]', count);
        summary.append(starLine, countLine);
      };

      const card = (review) => {
        const article = document.createElement('article');
        article.className = 'apollo-store-review';

        if (showPhotos && Array.isArray(review.i) && review.i.length) {
          const image = document.createElement('img');
          image.className = 'apollo-store-review__photo';
          image.src = review.i[0];
          image.alt = root.dataset.reviewPhoto;
          image.loading = 'lazy';
          article.appendChild(image);
        }

        const starLine = document.createElement('div');
        starLine.className = 'apollo-store-reviews__stars';
        starLine.textContent = stars(review.r);
        starLine.setAttribute('aria-label', review.r + ' out of 5 stars');
        article.appendChild(starLine);

        if (review.h) {
          const title = document.createElement('div');
          title.className = 'apollo-store-review__title';
          title.textContent = review.h;
          article.appendChild(title);
        }

        if (review.b) {
          const body = document.createElement('p');
          body.className = 'apollo-store-review__body';
          body.textContent = review.b;
          article.appendChild(body);
        }

        if (review.p) {
          const product = document.createElement('div');
          product.className = 'apollo-store-review__product';
          product.textContent = review.p;
          article.appendChild(product);
        }

        const meta = document.createElement('div');
        meta.className = 'apollo-store-review__meta';
        const author = document.createElement('strong');
        author.textContent = review.n || root.dataset.anonymous;
        meta.appendChild(author);
        if (review.v) {
          const verified = document.createElement('span');
          verified.className = 'apollo-store-review__verified';
          verified.textContent = '✓ ' + root.dataset.verified;
          meta.appendChild(verified);
        }
        if (review.d) {
          const date = document.createElement('time');
          date.dateTime = review.d;
          date.textContent = new Date(review.d + 'T00:00:00').toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          });
          meta.appendChild(date);
        }
        article.appendChild(meta);
        return article;
      };

      const render = (reviews, average, count) => {
        track.replaceChildren(...reviews.slice(0, max).map(card));
        renderSummary(average, count);
        track.setAttribute('aria-busy', 'false');
      };

      Promise.all([
        fetch(apiBase + '/reviews?scope=all&sort=newest&page=1&limit=' + max, {
          headers: { Accept: 'application/json' },
        }),
        fetch(apiBase + '/summary?scope=all', {
          headers: { Accept: 'application/json' },
        }),
      ])
        .then(async ([reviewsResponse, summaryResponse]) => {
          if (!reviewsResponse.ok || !summaryResponse.ok) throw new Error('load');
          const reviewsData = await reviewsResponse.json();
          const summaryData = await summaryResponse.json();
          render(
            reviewsData.reviews.map(normalizeLive),
            summaryData.average,
            summaryData.count,
          );
        })
        .catch(() => {
          const all = Array.isArray(window.APOLLO_REVIEWS) ? window.APOLLO_REVIEWS : [];
          if (root.dataset.staticFallback === 'true' && all.length) {
            const ordered = [...all].sort((a, b) => String(b.d).localeCompare(String(a.d)));
            const average =
              all.reduce((total, review) => total + Number(review.r || 0), 0) / all.length;
            render(ordered, average, all.length);
          } else {
            track.setAttribute('aria-busy', 'false');
            error.hidden = false;
          }
        });

      const scroll = (direction) =>
        track.scrollBy({ left: direction * track.clientWidth * 0.9, behavior: 'smooth' });
      root.querySelector('[data-review-prev]').addEventListener('click', () => scroll(-1));
      root.querySelector('[data-review-next]').addEventListener('click', () => scroll(1));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-archive-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.saqReady === "true") return;
    root.dataset.saqReady = "true";
    const copyNode = root.querySelector("[data-saq-copy]");
    const intro = root.querySelector('[data-screen="intro"]');
    const questionPanel = root.querySelector('[data-screen="question"]');
    const resultPanel = root.querySelector('[data-screen="result"]');
    const titleNode = root.querySelector("[data-question-title]");
    const storyNode = root.querySelector("[data-question-story]");
    const choicesNode = root.querySelector("[data-choices]");
    const backButton = root.querySelector('[data-action="back"]');
    const progressNode = root.querySelector("[data-progress]");
    const progressFill = root.querySelector("[data-progress-fill]");
    const currentNode = root.querySelector("[data-current]");
    const totalNode = root.querySelector("[data-total]");
    let copy;
    try {
      copy = JSON.parse(copyNode.textContent);
    } catch (error) {
      return;
    }
    const products = Array.from(root.querySelectorAll("[data-scent-card]")).map((card) => ({
      handle: card.dataset.handle,
      title: card.dataset.title,
      url: card.dataset.url,
      image: card.dataset.image,
      available: card.dataset.available === "true",
      price: card.dataset.price,
      primary: card.dataset.primary,
      format: card.dataset.format,
      families: (card.dataset.families || "").split(",").filter(Boolean),
      chapter: card.dataset.chapter,
      notes: card.dataset.notes,
      description: card.dataset.description
    }));
    const scores = { fresh: 0, floral: 0, gourmand: 0, shadow: 0 };
    const answers = [];
    let currentQuestion = 0;
    let currentWinner = null;
    let activeQuestions = [];
    let selectedRoute = null;
    let selectedFormat = null;
    let selectedCarry = null;
    let selectedMood = null;
    let selectedEntryIndex = null;
    let selectedTrailIndex = null;

    const make = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const changePanel = (visible) => {
      [intro, questionPanel, resultPanel].forEach((panel) => {
        panel.hidden = panel !== visible;
      });
    };
    const transition = (paint) => {
      const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (document.startViewTransition && !reduceMotion) {
        try {
          document.startViewTransition(paint);
          return;
        } catch (error) {
          paint();
          return;
        }
      }
      paint();
    };
    const renderQuestion = (index) => {
      currentQuestion = index;
      const question = activeQuestions[index];
      if (!question) return;
      changePanel(questionPanel);
      currentNode.textContent = String(index + 1);
      totalNode.textContent = String(activeQuestions.length);
      progressNode.setAttribute("aria-valuemax", String(activeQuestions.length));
      progressNode.setAttribute("aria-valuenow", String(index + 1));
      progressFill.style.width = (((index + 1) / activeQuestions.length) * 100) + "%";
      titleNode.textContent = question.title;
      if (index === 3) {
        const bridge = [
          copy.routeDepartures[selectedRoute],
          selectedCarry ? copy.carryEchoBefore + selectedCarry + copy.carryEchoAfter : "",
          selectedMood ? copy.trailPassages[selectedMood] : "",
          question.story
        ].filter(Boolean);
        storyNode.textContent = bridge.join(" ");
      } else {
        storyNode.textContent = question.story;
      }
      backButton.hidden = index === 0;
      backButton.disabled = index === 0;
      choicesNode.replaceChildren();
      question.choices.forEach((choice, choiceIndex) => {
        const button = make("button", "saq__choice");
        button.type = "button";
        const number = make("span", "saq__choice-number", String(choiceIndex + 1).padStart(2, "0"));
        number.setAttribute("aria-hidden", "true");
        const copyWrap = make("span", "saq__choice-copy");
        copyWrap.append(make("span", "saq__choice-title", choice.title));
        copyWrap.append(make("span", "saq__choice-detail", choice.detail));
        button.append(number, copyWrap);
        button.addEventListener("click", () => {
          if (index === 0) {
            selectedRoute = choice.route;
            selectedCarry = null;
            selectedMood = null;
            selectedEntryIndex = null;
            selectedTrailIndex = null;
            activeQuestions = [copy.opening, copy.routes[selectedRoute], null, copy.formatQuestion];
          } else if (index === 1) {
            selectedCarry = choice.carry;
            selectedMood = null;
            selectedEntryIndex = choiceIndex;
            selectedTrailIndex = null;
            activeQuestions[2] = copy.followUps[choice.next];
          } else if (index === 2) {
            selectedMood = Object.keys(choice.weights || {}).sort((a, b) => (choice.weights[b] || 0) - (choice.weights[a] || 0))[0] || null;
            selectedTrailIndex = choiceIndex;
          }
          selectedFormat = choice.format || null;
          Object.keys(scores).forEach((key) => { scores[key] = 0; });
          answers.length = index;
          answers[index] = choice.weights;
          answers.forEach((answer) => {
            Object.keys(answer || {}).forEach((key) => { scores[key] += answer[key]; });
          });
          transition(() => {
            if (index + 1 < activeQuestions.length) renderQuestion(index + 1);
            else renderResult();
          });
        });
        choicesNode.append(button);
      });
      titleNode.focus({ preventScroll: true });
    };
    const scoreProduct = (product, productScores) => {
      const familyTotal = product.families.reduce((sum, family) => sum + (productScores[family] || 0), 0);
      const familyMean = product.families.length ? familyTotal / product.families.length : 0;
      const primaryBonus = (productScores[product.primary] || 0) * 0.18;
      return Object.assign({}, product, { fit: familyMean + primaryBonus });
    };
    const rankedProducts = () => products.filter((product) => product.format === selectedFormat).map((product) => scoreProduct(product, scores)).sort((a, b) => {
      if (b.fit !== a.fit) return b.fit - a.fit;
      if (a.available !== b.available) return a.available ? -1 : 1;
      return a.title.localeCompare(b.title);
    });
    const balancedRecommendationsByFormat = {};
    const buildBalancedRecommendations = (format) => {
      const eligibleProducts = products.filter((product) => product.format === format);
      const paths = [];
      (copy.opening.choices || []).forEach((opening) => {
        const route = copy.routes[opening.route];
        if (!route) return;
        (route.choices || []).forEach((entry, entryIndex) => {
          const followUp = copy.followUps[entry.next];
          if (!followUp) return;
          (followUp.choices || []).forEach((trail, trailIndex) => {
            const pathScores = { fresh: 0, floral: 0, gourmand: 0, shadow: 0 };
            [opening.weights, entry.weights, trail.weights].forEach((weights) => {
              Object.keys(weights || {}).forEach((family) => {
                pathScores[family] += Number(weights[family]) || 0;
              });
            });
            paths.push({ key: [opening.route, entryIndex, trailIndex].join(":"), scores: pathScores });
          });
        });
      });
      const assignments = new Map();
      if (!eligibleProducts.length || !paths.length) return assignments;
      const counts = new Map(eligibleProducts.map((product) => [product.handle, 0]));
      const pairings = paths.flatMap((path) => eligibleProducts.map((product) => ({
        pathKey: path.key,
        product: scoreProduct(product, path.scores)
      }))).sort((a, b) => {
        if (b.product.fit !== a.product.fit) return b.product.fit - a.product.fit;
        const titleOrder = a.product.title.localeCompare(b.product.title);
        return titleOrder || a.pathKey.localeCompare(b.pathKey);
      });
      const minimumPerProduct = Math.floor(paths.length / eligibleProducts.length);
      const assignWithinLimit = (limit) => {
        for (const pairing of pairings) {
          if (assignments.has(pairing.pathKey)) continue;
          const count = counts.get(pairing.product.handle) || 0;
          if (count >= limit) continue;
          assignments.set(pairing.pathKey, pairing.product);
          counts.set(pairing.product.handle, count + 1);
          if (assignments.size === paths.length) break;
        }
      };
      assignWithinLimit(minimumPerProduct);
      assignWithinLimit(minimumPerProduct + 1);
      return assignments;
    };
    const balancedWinnerForCurrentPath = () => {
      if (!balancedRecommendationsByFormat[selectedFormat]) {
        balancedRecommendationsByFormat[selectedFormat] = buildBalancedRecommendations(selectedFormat);
      }
      const pathKey = [selectedRoute, selectedEntryIndex, selectedTrailIndex].join(":");
      return balancedRecommendationsByFormat[selectedFormat].get(pathKey);
    };
    const resetReading = () => {
      Object.keys(scores).forEach((key) => { scores[key] = 0; });
      answers.length = 0;
      currentWinner = null;
      selectedRoute = null;
      selectedFormat = null;
      selectedCarry = null;
      selectedMood = null;
      selectedEntryIndex = null;
      selectedTrailIndex = null;
      currentQuestion = 0;
      activeQuestions = [copy.opening, null, null, copy.formatQuestion];
    };
    const createMiniMatch = (product, label) => {
      const link = make("a", "saq__alternative");
      link.href = product.url;
      if (label) link.append(make("span", "saq__result-label", label));
      const name = make("span", "saq__alternative-name", product.title);
      const note = make("span", "saq__alternative-note", product.notes);
      link.append(name, note);
      return link;
    };
    const renderResult = () => {
      const ranked = rankedProducts();
      if (!ranked.length) {
        resultPanel.replaceChildren(make("p", "saq__result-story", copy.emptyResult));
        changePanel(resultPanel);
        return;
      }
      const winner = balancedWinnerForCurrentPath() || ranked[0];
      currentWinner = winner;
      const formatTitle = selectedFormat === "wax_melt" ? copy.waxFormat : copy.candleFormat;
      const routeTitle = copy.routeLabels[selectedRoute] || "The Archive";
      const cleanScentTitle = winner.title
        .replace(/\s+-\s+Things That Shouldn't Exist$/i, "")
        .replace(/\s+(?:Opulent Wax Cubes|Candle)$/i, "");
      const introWrap = make("div", "saq__result-intro");
      introWrap.append(make("p", "saq__result-label", copy.resultEyebrow));
      introWrap.append(make("h2", "saq__result-heading", copy.resultHeadingBefore + cleanScentTitle + copy.resultHeadingAfter));
      introWrap.append(make("p", "saq__result-label", copy.matchLabel + " · " + formatTitle + " · " + routeTitle));
      const resultStory = [
        copy.routeEndings[selectedRoute] || "The house falls quiet behind you.",
        selectedCarry ? copy.carryEchoBefore + selectedCarry + copy.carryEchoAfter : "",
        selectedMood ? copy.trailEndings[selectedMood] : ""
      ].filter(Boolean).join(" ");
      introWrap.append(make("p", "saq__result-story", resultStory));
      if (winner.description) introWrap.append(make("p", "saq__result-character", winner.description));
      const card = make("article", "saq__match-card");
      const imageWrap = make("div", "saq__match-image-wrap");
      if (winner.image) {
        const image = make("img", "saq__match-image");
        image.src = winner.image;
        image.alt = winner.title;
        image.loading = "eager";
        imageWrap.append(image);
      }
      const matchCopy = make("div", "saq__match-copy");
      matchCopy.append(make("p", "saq__chapter-name", winner.chapter));
      matchCopy.append(make("h3", "saq__match-title", winner.title));
      matchCopy.append(make("p", "saq__result-label", copy.notesLabel));
      matchCopy.append(make("p", "saq__notes", winner.notes));
      const priceRow = make("div", "saq__price-row");
      if (winner.available) priceRow.append(make("span", "saq__stock", copy.availableNow));
      priceRow.append(make("span", "", copy.priceLabel + ": " + winner.price));
      matchCopy.append(priceRow);
      const actions = make("div", "saq__actions");
      const shopLink = make("a", "saq__button-link", winner.available ? copy.shopScent : copy.readScent);
      shopLink.href = winner.url;
      actions.append(shopLink);
      const restartButton = make("button", "saq__share", copy.restart);
      restartButton.type = "button";
      actions.append(restartButton);
      matchCopy.append(actions);
      restartButton.addEventListener("click", () => {
        resetReading();
        transition(() => changePanel(intro));
      });
      card.append(imageWrap, matchCopy);
      const resultContent = make("div", "saq__result-content");
      resultContent.append(introWrap, card);
      const availableAlternative = ranked.find((product) => product.available && product.handle !== winner.handle);
      if (!winner.available && availableAlternative) {
        const alternatives = make("div", "saq__alternatives");
        alternatives.append(createMiniMatch(availableAlternative, copy.availableAlternative));
        resultContent.append(alternatives);
      } else if (winner.available) {
        const related = ranked.filter((product) => product.available && product.handle !== winner.handle).slice(0, 2);
        if (related.length) {
          const heading = make("p", "saq__result-label saq__related-heading", copy.relatedHeading);
          const alternatives = make("div", "saq__alternatives");
          related.forEach((product) => alternatives.append(createMiniMatch(product, product.available ? copy.availableNow : "")));
          resultContent.append(heading, alternatives);
        }
      }
      resultPanel.replaceChildren(resultContent);
      changePanel(resultPanel);
      resultPanel.querySelector(".saq__result-heading").setAttribute("tabindex", "-1");
      resultPanel.querySelector(".saq__result-heading").focus({ preventScroll: true });
    };
    root.querySelector('[data-action="start"]').addEventListener("click", () => {
      resetReading();
      transition(() => renderQuestion(0));
    });
    backButton.addEventListener("click", () => {
      if (currentQuestion > 0) transition(() => renderQuestion(currentQuestion - 1));
    });
  };
  const initAll = (scope) => {
    if (scope && scope.matches && scope.matches("[data-scent-archive]")) init(scope);
    if (scope && scope.querySelectorAll) scope.querySelectorAll("[data-scent-archive]").forEach(init);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll(document), { once: true });
  else initAll(document);
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
